import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import LanguageSwitcher from './LanguageSwitcher';
import { useLocation } from 'react-router-dom';

const GlobalLanguageSwitcher = () => {
    const theme = useTheme();
    const location = useLocation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Pages where the Header is already present (Layouts or AdminLayout)
    const pagesWithHeader = [
        '/dashboard',
        '/account',
        '/nrcme',
        '/help',
        '/forms',
        '/resources',
        '/physical',
        '/vitals',
        '/documents',
        '/documents-driver',
        '/survey',
        '/user-history',
        '/user/clinic-office',
        '/user/clinic-user',
        '/user/invited-driver',
        '/user/provider',
        '/user/add-driver',
        '/admin-section',
        '/kiosk-mode',
        '/kiosk'
    ];

    const hasHeader = pagesWithHeader.some(path => location.pathname.startsWith(path)) || location.pathname === '/';

    if (hasHeader) return null;

    return (
        <Box
            className="notranslate"
            sx={{
                position: 'fixed',
                top: isMobile ? 10 : 20,
                right: isMobile ? 10 : 20,
                zIndex: 1000,
            }}
        >
            <LanguageSwitcher />
        </Box>
    );
};

export default GlobalLanguageSwitcher;
